import styled from 'styled-components';
import {MobileSelectModal} from '@guestapp/old-ui-kit';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledMobileSelectModal = styled(MobileSelectModal)`
  & > div {
    height: auto;
  }
`;

export const ContentSheet = styled(Content)``;

export const Text = styled.p`
  width: 300px;
  text-align: center;
  margin-bottom: 24px;
`;

export const Title = styled.div`
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  text-align: center;
  margin: auto 0 16px;
  color: ${props => props.theme.colors.branding.fontPrimary};
  font-size: 1.125rem;
  line-height: 1.5;
  font-weight: 600;
  font-family: ${props => props.theme.fonts.fontFamily.titles.font_name};
`;
